import React from 'react';
import PropTypes from 'prop-types';
import StepHeader from '../step-header';
import StepWrapper from './step-wrapper';
import CircularProgress from './tone-step/circular-progress-bar';
var DefaultContent = function DefaultContent(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "step__title"
  }, /*#__PURE__*/React.createElement("span", {
    className: "step-circle"
  }, "1"), " ", content.Heading), /*#__PURE__*/React.createElement("p", {
    className: "step__body"
  }, content.Body), /*#__PURE__*/React.createElement("h2", {
    className: "step__title"
  }, /*#__PURE__*/React.createElement("span", {
    className: "step-circle"
  }, "2"), " ", content.Heading2));
};
var IconsContent = function IconsContent(_ref2) {
  var content = _ref2.content;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
    className: "step__title icons"
  }, content.Heading), /*#__PURE__*/React.createElement("div", {
    className: "step__body icons"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__body__item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__body__item__icon no-sound"
  }), /*#__PURE__*/React.createElement("p", {
    className: "step__body__item__icon-desc"
  }, content.Heading2)), /*#__PURE__*/React.createElement("div", {
    className: "step__body__item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__body__item__icon headphones"
  }), /*#__PURE__*/React.createElement("p", {
    className: "step__body__item__icon-desc"
  }, content.Body)), /*#__PURE__*/React.createElement("div", {
    className: "step__body__item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__body__item__icon volume"
  }), /*#__PURE__*/React.createElement("p", {
    className: "step__body__item__icon-desc"
  }, content.Question))));
};
var ToneCalibrationIntroStep = function ToneCalibrationIntroStep(_ref3) {
  var content = _ref3.content,
    version = _ref3.version,
    onNextClick = _ref3.onNextClick;
  return /*#__PURE__*/React.createElement(StepWrapper, {
    backgroundImage: content.BackgroundImage,
    stepClassNames: "step--tone-calibration-intro"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__text"
  }, /*#__PURE__*/React.createElement(StepHeader, {
    icon: content.StepHeaderIcon,
    header: content.StepHeaderTitle
  }), /*#__PURE__*/React.createElement("div", {
    className: "tone-progress"
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    sqSize: 60,
    strokeWidth: 10,
    percentage: 0,
    showPercentage: true
  })), version === 'default' && /*#__PURE__*/React.createElement(DefaultContent, {
    content: content
  }), version !== 'default' && /*#__PURE__*/React.createElement(IconsContent, {
    content: content
  })), /*#__PURE__*/React.createElement("div", {
    className: "step__buttons"
  }, /*#__PURE__*/React.createElement("button", {
    className: "step-button like-orange-button-large",
    onClick: function onClick(e) {
      e.preventDefault();
      onNextClick();
    }
  }, content.NextButtonLabel)));
};
ToneCalibrationIntroStep.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  onNextClick: PropTypes.func.isRequired
};
export default ToneCalibrationIntroStep;